module.exports = __webpack_public_path__ + "9a873857d288c65700b3fa13dd63c2a7.pdf";